export default __webpack_public_path__ + "static/media/vaccineIllustration3.57e2fd90.gif";